/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unknown-property */
/* eslint-disable react/sort-comp */
import React, { Component, Fragment, useContext } from "react";
import _ from "lodash";
import moment from "moment";
import { Col, Row, Icon, Spin, Button, Form, Select, Popconfirm, Input, TextArea, Checkbox, InputNumber, FormItem } from "../../common/UIComponents";
import {
    isEmpty,
    checkNegitive,
    findTotal,
    alertMessage,
    doFormate,
    base64ToPdf,
} from "../../common/Common";
import I18n from "../../common/I18n";
import AppConfig from "../../config/AppConfig";
import { fetchOrganizationDetails } from "../../api/Organisations";
import EditEstimateModal from "../../stories/components/EditEstimateModal";

import {
    invoiceHeading,
    mainHeading,
    shipperHeading,
    invoiceItem,
    totalItems,
    marginTop40,
    marginTop20,
    textBold,
    marginTop10,
    fontSize10,
    paddingTop20,
    smallContent,
    commentSection,
    borderLine,
    heading,
    alignCenter,
    alignRight,
    padding5,
    borderCollapseInherit,
    marginLeft10,
    floatLeft,
} from "../../helpers/invoice_styles";
import logo from "../../../assets/images/logo-thumbnail.png";
import userStore from "../../stores/UserStore";
import {
    deleteAdjustment,
    fetchQuotationDetails,
    getContactEmails,
    printQuoteOrdersPdf,
    saveInvoice,
    updateEstimateAdjustments,
} from "../../api/Billing";
import { checkServiceExistance, formatUSPhoneNumber, renderAlertMessage } from "../../helpers/common";
import { findSpanValue } from "../../helpers/billing";
// import BranchesIcon from "../common/BranchesIcon";
import BaseModal from "../../components/BaseModal";
import { validateEmailList } from "../../components/billing_screen/helpers";
import { OrgContext } from "../../context/OrgContext";
import { withRouter } from "react-router-dom";
import { sendEmailsForEstimateBilling } from "../../api/OrdersApi";
import RegenerationalConfirmationModal from "../../common/RegenerationalConfirmationModal";
// import ManageInvoiceLine from "./ManageInvoiceLine";
import { PrintEstimateIcon, PickupIconEstimate, DeliveryIconEstimate, AdditionIcon, TrashIcon } from "../../common/CustomIcon";
import Button_v2 from "../../stories/components/Button_v2";
import AddressInfo from "../../components/common/AddressInfo";
import HawbMawbNo from "../../components/billing/HawbMawbNo";
import noImg from "../../../assets/images/noImg.png";
import { getOrderTypeIcon, renderNotification } from "../../components/orders/OrderTypeIcons";
import ReusableInput from "./ReusableInput";
import GLCodeSelect from "../../components/common/SelectDropdowns/GLCodeSelect";
import PrepaidAmountWithPreview from "../../components/billing/PrepaidAmountWithPreview";

class FormComponent extends Component {
    constructor(props) {
        PrintEstimateIcon
        super(props);
        this.state = {
            account: this.props.account ? this.props.account : {},
            invoice: !isEmpty(this.props.currentInvoice)
                ? this.props.currentInvoice
                : {
                    account_details: {},
                    warehouse_details: {},
                    driver_details: {},
                    order_info: {},
                },
            logo,
            chargeTypes: [
                "transportation_charges",
                "fuel_surcharges",
                "accessorial_charges",
                "adjustment_charges",
            ],
            callInvoceDetails: this.props.callInvoceDetails
                ? this.props.callInvoceDetails
                : false,
            order_id: this.props.order_id,
            showHeading:
                this.props.showHeading === false ? this.props.showHeading : true,
            showOtherDetails:
                this.props.showOtherDetails === false
                    ? this.props.showOtherDetails
                    : true,
            inProgress: false,
            order_references: {},
            printProgress: false,
            showEmailModal: false,
            isLoadingEmailData: false,
            listOfEmails: [],
            contactsData: [],
            subject: '',
            description: '',
            orgSettings: props.organizationSettings,
            isSendingEmailData: false,
            activeKey: '',
            currentOrderGroupType: this.props.currentOrderGroupType || "",
            dataToEdit: null,
            isEstimateModalVisible: false,
            estimateData: {
                pickup: { distance: 0, rate: 0 },
                delivery: { distance: 0, rate: 0 },
            },
            dataSource: [
                { key: '1', stop: 'Pickup', distance: 0, rate: 0, includesFuel: true },
                { key: '2', stop: 'Delivery', distance: 0, rate: 0, includesFuel: true },
            ],
            glCodesList: this.props.glCodesList,
            invoice_ref: [],
            delete_invoice_line_ids: [],
        };
    }

    componentDidMount() {
        this.getOrgLogo();
        this.setInvoiceDetails();
        this.setState({ openEmailModal: this.props.openEmailModal, editMode: this.props.editMode, update: this.props.showDrawer, saveCall: this.props.saveCall})
    }

    componentDidUpdate(prevState, prevProps) {
        if (this.props.activeKey !== this.state.activeKey) {
            this.setState({
                activeKey: this.props.activeKey
            }, () => {
                if (this.props.activeKey == "billing") {
                    this.handleGenerateQuotation(this.state.order_id);
                }
            })
        }
        if(this.props.openEmailModal !== this.state.openEmailModal) {
            this.setState({
                openEmailModal: this.props.openEmailModal
            }, () => {
                if(this.props.openEmailModal) {
                    this.showEmailModal();
                }
            })
        }
        if(this.props.editMode !== this.state.editMode) {
            this.setState({ editMode : this.props.editMode})
            if(!this.props.edit) {
                this.getBillingDetails();
            }
        }
        if(this.props.showDrawer !== this.state.update) {
            this.setState({ update: this.props.showDrawer})
            this.props.showDrawer && this.setInvoiceDetails()
        }
        if(this.props.saveCall !== this.state.saveCall) {
            this.setState({ saveCall: this.props.saveCall })
            this.props.saveCall && this.handleAdjustmentsSave()
        }
    }

    // handleDelete = (id) => {
    //     // setIsLoading(true);
    //     this.setState({ inProgress: true })
    //     deleteAdjustment({
    //         invoice_line_id: id
    //     }).then((result) => {
    //         if (result.success) {
    //             alertMessage(
    //                 result.message ? result.message : I18n.t("messages.deleted"),
    //                 "success",
    //                 10
    //             );
    //             // getInvoiceLines();
    //             this.setInvoiceDetails();
    //         } else {
    //             renderAlertMessage(result.errors);
    //         }
    //     })
    //     .finally(() => {
    //         this.setState({ inProgress: false })
    //     });
    // };

    handleDelete = (itemIndex) => {
        const updatedInvoice = { ...this.state.invoice_ref };
        const updatedAdjustmentCharges = [...updatedInvoice.adjustment_charges];
        const deletedRow = updatedAdjustmentCharges[0].price_list[itemIndex];
    
        if (deletedRow.id) {
            this.setState(prevState => ({
                delete_invoice_line_ids: [...(prevState.delete_invoice_line_ids || []), deletedRow.id]
            }));
        }
    
        updatedAdjustmentCharges[0].price_list.splice(itemIndex, 1);
    
        this.setState({
            invoice_ref: {
                ...updatedInvoice,
                adjustment_charges: updatedAdjustmentCharges
            }
        });
    };
    
    handleAddRow = () => {
        const newRow = {
            invoice_name: "",
            gl_code: "",
            invoice_quantity: 1,
            invoice_value: 1
        }
    
        const updatedInvoice = { ...this.state.invoice_ref };
        const updatedAdjustmentCharges = [...updatedInvoice.adjustment_charges];
    
        updatedAdjustmentCharges[0] = {
            ...updatedAdjustmentCharges[0],
            price_list: [...updatedAdjustmentCharges[0].price_list, newRow],
        };
    
        this.setState({
            invoice_ref: {
                ...updatedInvoice,
                adjustment_charges: updatedAdjustmentCharges,
            },
        });
    };
    

    handleChange = (field, value, itemIndex) => {
        const updatedInvoice = { ...this.state.invoice_ref };
        const updatedAdjustmentCharges = [...updatedInvoice.adjustment_charges];

        if (field === 'location_details') {
            const selectedLocation = this.props.order.locations.find(
                loc => loc.type_of_loc === value
            );
    
            if (selectedLocation) {
                updatedAdjustmentCharges[0].price_list[itemIndex] = {
                    ...updatedAdjustmentCharges[0].price_list[itemIndex],
                    location_id: selectedLocation.id,
                    location_type: selectedLocation.type_of_loc
                }
            }
        } else {
            updatedAdjustmentCharges[0].price_list[itemIndex] = {
                ...updatedAdjustmentCharges[0].price_list[itemIndex],
                [field]: value,
            };
        }
        this.setState({
            invoice_ref: {
                ...updatedInvoice,
                adjustment_charges: updatedAdjustmentCharges
            }
        });
    };

    handleAdjustmentsSave = () => {
        const { form } = this.props
        form.validateFields(async (err, values) => {
            if (!err) {
                const { invoice, invoice_ref, order_id, delete_invoice_line_ids } = { ...this.state }
                const status = this.props.order.status
                const invoice_adjustments = [...invoice.adjustment_charges[0].price_list]
                const invoice_ref_adjustments = [...invoice_ref.adjustment_charges[0].price_list]

                let filteredInvoiceRef = invoice_ref_adjustments.filter(refObj => {
                    return !invoice_adjustments.some(invoiceObj => this.areObjectsEqual(invoiceObj, refObj))
                })

                filteredInvoiceRef = filteredInvoiceRef.map(obj => {
                    return {
                        invoice_line_id: obj.id || "",
                        invoice_name: obj.invoice_name || "",
                        invoice_value: obj.invoice_value || 0,
                        invoice_quantity: obj.invoice_quantity || 0,
                        invoice_type: "Adjustments",
                        gl_code: obj.gl_code || "",
                        location_id: this.props.order.locations.length === 1 ? this.props.order.locations[0].location_id : obj.location_id,
                        location_type: this.props.order.locations.length === 1 ? this.props.order.locations[0].type_of_loc : obj.location_type,
                    }
                })

                const payload = {
                    customer_order_id: order_id,
                    new_invoice_lines: filteredInvoiceRef,
                    delete_invoice_line_ids: delete_invoice_line_ids,
                    status: status
                }

                try {
                    const result = await updateEstimateAdjustments(payload)
                    if(result.success) {
                        this.getBillingDetails();
                        this.handleGenerateQuotation(this.state.order_id)
                    }
                    else {
                        renderNotification(result.errors, "error")
                    }
                } catch {
                    console.log("unsuccessful")
                } finally {
                    this.setState({
                        delete_invoice_line_ids: []
                    })
                    this.props.handleSaveCall(false)
                }
            }
        })
        this.props.handleSaveCall(false)
    }

    areObjectsEqual = (obj1, obj2) => {
        const keys1 = Object.keys(obj1)
        const keys2 = Object.keys(obj2)

        if(keys1.length !== keys2.length) {
            return false
        }

        return keys1.every(key => obj1[key] === obj2[key])
    }

    showEstimateModal = () => {
        const { invoice } = this.state;
        const transportationCharges = invoice?.transportation_charges || [];
        const pickupRate = transportationCharges[0]?.price_list?.reduce((acc, item) => acc + item.invoice_value, 0) || 0;
        const deliveryRate = transportationCharges[1]?.price_list?.reduce((acc, item) => acc + item.invoice_value, 0) || 0;

        this.setState({
            isEstimateModalVisible: true,
            estimateData: {
                pickup: { rate: pickupRate },
                delivery: { rate: deliveryRate },
            },
            dataSource: [
                { key: '1', stop: 'Pickup', distance: 0, rate: pickupRate, includesFuel: true },
                { key: '2', stop: 'Delivery', distance: 0, rate: deliveryRate, includesFuel: true },
            ],
        });
    };

    handleEstimateModalCancel = () => {
        this.setState({ isEstimateModalVisible: false });
    };

    // Function to handle OK click in the modal
    handleEstimateModalOk = () => {
        const { dataSource } = this.state;
        const order_id = this.state.order_id;

        // Prepare the payload for the API call
        const payload = {
            order_id,
            transportation_charges: dataSource.map(item => ({
                order_id: order_id, // Assuming the order_id is the same for both pickup and delivery
                price_list: [
                    {
                        invoice_name: "Transportation Charges",
                        invoice_value: item.rate,
                    },
                ],
            })),
        };
        saveInvoice(payload)
            .then(result => {
                if (result.success) {
                    alertMessage(I18n.t("messages.invoice_updated"));
                    this.setState({
                        isEstimateModalVisible: false,
                        callInvoceDetails: true, // Refresh invoice details
                    }, () => {
                        this.setInvoiceDetails();
                    });
                } else if (result.errors) {
                    renderAlertMessage(result.errors);
                }
            });
    };

    handleTableChange = (value, key, columnKey) => {
        const newData = this.state.dataSource.map((item) => {
            if (item.key === key) {
                return { ...item, [columnKey]: value };
            }
            return item;
        });
        this.setState({ dataSource: newData });
    };

    calculateTotals = () => {
        let totalDistance = 0;
        let totalRate = 0;

        this.state.dataSource.forEach((item) => {
            totalDistance += parseFloat(item.distance) || 0;
            totalRate += parseFloat(item.rate) || 0;
        });

        return {
            totalDistance: totalDistance.toFixed(2),
            totalRate: totalRate.toFixed(2),
        };
    };





    setInvoiceDetails = (callInvoceDetails = true) => {
        if (
            this.state.callInvoceDetails === true &&
            checkServiceExistance("OQIND")
        ) {
            if (callInvoceDetails) {
                this.getBillingDetails();

            }
        } else {
            this.setUpdateRefs();
        }
    };

    getBillingDetails = () => {
        this.setState({ inProgress: true });
        const isForQuote = false;
        fetchQuotationDetails(this.state.order_id).then((result) => {
            if (result.success) {
                const invoice = result?.invoice ? result.invoice : {};
                invoice.is_for_invoice_quote = isForQuote;
                if (this.props.updateQuote) {
                    this.props.updateQuote(this.state.order_id, invoice.total_amount);
                }
                this.setState(
                    {
                        invoice,
                        inProgress: false,
                        invoice_ref: _.cloneDeep(invoice),
                    },
                    () => {
                        this.setUpdateRefs();
                    }
                );
            } else if (result.errors) {
                renderAlertMessage(result.errors)
                this.setState({ inProgress: false });
            }
        });   
    };

    getContacts = () => {
        const account = _.get(this.state, "invoice.account_details", {});
        const accId = _.get(account, "id", "");
        this.setState({ isLoadingEmailData: true });
        getContactEmails(accId).then((result) => {
            if (result.success) {
                this.setState({ contactsData: result.contact_emails || [] });
            } else if (result.errors) {
                renderAlertMessage(result.errors)
                this.setState({ isLoadingEmailData: false });
            }
        }).finally(() => {
            this.setState({ isLoadingEmailData: false });
        });
    };

    setUpdateRefs = () => {
        const { invoice, order_references } = this.state;
        if (
            invoice?.transportation_charges &&
            invoice.transportation_charges.length > 0
        ) {
            invoice.transportation_charges.map((order) => {
                order_references[order.order_number] = {};
                order_references[order.order_number].hawb = order.hawb; // doFormate(order.hawb);
                order_references[order.order_number].mawb = order.mawb;
            });
            this.setState({
                order_references,
            });
        }
    };

    handleGenerateQuotation = (id) => {
        this.setState({ inProgress: true });
        const isForQuote = false;
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0];
        saveInvoice({ order_id: id, is_for_invoice_quote: "true", current_date: formattedDate }).then(
            (result) => {
                if (result.success) {
                    alertMessage(I18n.t("messages.quote_generated"));
                    this.getBillingDetails();
                    const invoice =
                        !isEmpty(result.invoice) && _.isObject(result.invoice)
                            ? result.invoice
                            : {};
                    invoice.is_for_invoice_quote = isForQuote;
                    if (this.props.updateQuote) {
                        this.props.updateQuote(this.state.order_id, invoice.total_amount);
                    }
                    this.setState({
                        //  invoice,
                        inProgress: false,
                    });
                } else if (result.errors) {
                    renderAlertMessage(result.errors)
                    this.setState({ inProgress: false });
                }
            }
        );
    };

    handleUpdateAmount = (result) => {
        const isForQuote = false;
        if (result.success) {
            alertMessage(I18n.t("messages.quote_generated"));
            this.getBillingDetails();
            const invoice =
                !isEmpty(result.invoice) && _.isObject(result.invoice)
                    ? result.invoice
                    : {};
            invoice.is_for_invoice_quote = isForQuote;
            if (this.props.updateQuote) {
                this.props.updateQuote(this.state.order_id, invoice.total_amount);
            }
        } else if (result.errors) {
            renderAlertMessage(result.errors)
        }
    }

    handlePrintBills = async (id) => {
        // const selectedIds = !isEmpty(orderIds) ? orderIds : [];
        this.setState({ printProgress: true });
        try {
            let result = await printQuoteOrdersPdf(id);
            if (result.success) {
                base64ToPdf(
                    result.quote_orders_pdf,
                    `BillingEstimates-${moment().format("YYYY-MM-DDTHH:mm:ss")}.pdf`
                );
            } else {
                if (result.errors.length > 0) {
                    alertMessage(result.errors.join(", "), "error", 10);
                }
            }
        } catch (error) {
            alertMessage(error.message, "error", 10);
        } finally {
            this.setState({ printProgress: false });
        }
    };
    componentWillReceiveProps = (nextProps) => {
        if (nextProps.setData === true) {
            this.setInvoiceDetails();
        }
    };

    getOrgLogo = () => {
        const orgId = userStore.getStateValue("selectedOrg");
        fetchOrganizationDetails(orgId).then((result) => {
            if (result.success) {
                const organization = result.organization || {};
                organization.logo =
                    !isEmpty(organization.logo) && organization.logo.url
                        ? organization.logo.url
                        : "";

                if (organization.logo) {
                    this.setState({
                        logo: organization.logo,
                    });
                } else if (!isEmpty(orgId)) {
                    const urlToFile = `${AppConfig.baseUrl}/org_logos/${orgId}/org_logo.png`;
                    fetch(urlToFile).then((response) => {
                        if (response.status === 200) {
                            this.setState({
                                logo: urlToFile,
                            });
                        }
                    });
                }
            }
        });
    };

    handleSubmit = () => {
        const { currentOrg } = this.props
        const payload = {
            organization_id: _.get(currentOrg, "id", ""),
            customer_order_ids: this.props.order_id,
            email_ids: this.state.listOfEmails,
            subject: this.state.subject,
            description: this.state.description,
        };
        this.setState({ isSendingEmailData: true });
        sendEmailsForEstimateBilling(payload)
            .then((result) => {
                if (result.success) {
                    alertMessage(result.data.message, "success");
                    this.setState({ showEmailModal: false });
                    this.props.handleEmailModal(false)
                } else if (result.errors) {
                    renderAlertMessage(result.errors);
                }
            })
            .finally(() => {
                this.setState({ isSendingEmailData: false });
            });
    };


    handleCancel = () => {
        this.setState({ showEmailModal: false, listOfEmails: [] });
        this.props.handleEmailModal(false)
    }

    handleAddingEmails = (emails) => {
        const validatedEmails = validateEmailList(emails);
        this.setState({ listOfEmails: validatedEmails });
    }

    showEmailModal = () => {
        const { orgSettings } = this.state;
        const { invoice_body_text } = orgSettings;
        this.setState({
            showEmailModal: true,
            subject: `Estimate For ${_.get(this.state, "invoice.order_number", "")}`,
            description: invoice_body_text || I18n.t('configurations.default_email_body_message')
        });
        this.getContacts();
    }

    findSectionTotal = (sectionType) => {
        const { invoice_ref } = this.state;
        const charges = [...invoice_ref[sectionType]];
        const priceList =
            !isEmpty(charges) && charges.length > 0
                ? charges.map((order) => order.price_list)
                : [];
        const flattenList = _.flatten(priceList);
        const amount = findTotal(flattenList, "invoice_value", 1, true);
        return amount || 0.0;
    };

    renderTermsNConditions = () => (
        <div style={{ ...marginTop40, ...borderLine }}>
            <Row>
                <Col xs={24} className="heading">
                    {I18n.t("invoices.termsNconditions")}
                </Col>
            </Row>
            {AppConfig.termsList.map((term, index) => (
                <p className="paddingLeft5">
                    {index + 1}. {term}
                </p>
            ))}
        </div>
    );

    renderComments = () => (
        <div style={{ ...marginTop40, ...borderLine }}>
            <div style={{ ...heading }}>{I18n.t("invoices.comments")}</div>
            <div style={{ ...commentSection }} />
        </div>
    );

    renderEmailModal = () => {
        return (
            <BaseModal
                title={I18n.t("general.send_email")}
                onCancel={this.handleCancel}
                visible={this.state.showEmailModal}
                width="50%"
                maskClosable={false}
            >
                <Spin spinning={this.state.isLoadingEmailData} delay={1000}>
                    <Row className="tagsInput emailForm" type="flex" align="middle" gutter={8}>
                        <Col xs={21}>
                            <FormItem label={I18n.t("general.emails")}>
                                <Select
                                    value={this.state.listOfEmails}
                                    mode="tags"
                                    onChange={this.handleAddingEmails}
                                    style={{ width: "100%" }}
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    }
                                    tokenSeparators={[","]}
                                >
                                    {this.state.contactsData?.map((contact) => (
                                        <Select.Option key={contact}>
                                            {contact}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </FormItem>
                        </Col>
                        <Col xs={3}>

                            <Button
                                onClick={() => this.handleSubmit()}
                                type="primary"
                                loading={this.state.isSendingEmailData}
                                icon="mail"
                                style={{ backgroundColor: "#607AD6", color: "#fff" }}
                                size="small"
                            >
                                Send
                            </Button>

                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormItem label={"Subject"}>
                                <Input
                                    rows={4}
                                    placeholder={"Subject"}
                                    className="sop-form-textArea"
                                    value={this.state.subject}
                                    onChange={(e) => this.setState({ subject: e.target.value })}
                                />
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormItem label={"Description"}>
                                <TextArea
                                    rows={4}
                                    placeholder={"Description"}
                                    className="sop-form-textArea"
                                    value={this.state.description}
                                    onChange={(e) => this.setState({ description: e.target.value })}
                                />
                            </FormItem>
                        </Col>
                    </Row>
                </Spin>
            </BaseModal>
        );
    };

    renderWHDetails = () => {
        const whDetails = this.state.invoice_ref.warehouse_details || {};
        return (
            <table width="100%">
                <tbody>
                    <tr>
                        <td>
                            <img src={this.state.logo} alt="" style={{ maxWidth: "10rem" }} />
                        </td>
                    </tr>
                    <tr>
                        <td width="65%">
                            <h2 style={{ ...mainHeading, ...textBold }}>{whDetails.name}</h2>
                        </td>
                        <td width="35%">
                            <h2 style={{ ...alignCenter, ...invoiceHeading, ...textBold }}>
                                INVOICE
                            </h2>
                        </td>
                    </tr>
                    <tr>
                        <td width="65%" style={{ ...smallContent }}>
                            <table width="100%" style={{ ...marginTop10 }} cellpadding="0px">
                                <tbody>
                                    <tr>
                                        <td style={{ ...smallContent }}>
                                            <AddressInfo
                                                address={(whDetails && whDetails.address) || {}}
                                                showIcon
                                                displayType="line"
                                            />
                                        </td>
                                    </tr>
                                    {!isEmpty(whDetails.email) && (
                                        <tr>
                                            <td>
                                                <Icon type="mail" /> &nbsp; {whDetails.email}
                                            </td>
                                        </tr>
                                    )}
                                    {!isEmpty(whDetails.contact) && (
                                        <tr>
                                            <td>
                                                <Icon type="phone" /> &nbsp;{" "}
                                                {formatUSPhoneNumber(whDetails.contact)}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </td>
                        <td width="35%" style={{ ...smallContent }}>
                            <table cellpadding="2px" cellspacing="0px" width="100%">
                                <tbody>
                                    <tr>
                                        <td width="46%">{I18n.t("order.order_no")}</td>
                                        <td width="4%">:</td>
                                        <td width="50%">#{this.state.invoice.order_number} </td>
                                    </tr>
                                    <tr>
                                        <td>{I18n.t("general.date")}</td>
                                        <td>:</td>
                                        <td>
                                            {moment(this.state.invoice.date).format("MMM Do YYYY")}{" "}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    };

    renderShipperDetails = () => {
        const data = this.state.invoice.account_details || {};
        const { billing_address, address } = data;
        const order_info = _.get(this.state.invoice, "order_info", {});
        return this.state.invoice.order_group_type !== "MANUAL" ? (
            <table width="100%" style={{ ...marginTop10 }} cellpadding="0px">
                <tbody>
                    <tr>
                        <td width="65%">
                            <table width="100%">
                                <tbody>
                                    <tr>
                                        <td style={{ ...shipperHeading, ...textBold }}>
                                            <h3>{I18n.t("invoices.billed_to")}</h3>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ ...smallContent }}>
                                            <h4>{this.state.invoice.account_details.name}</h4>
                                            <AddressInfo
                                                // address={(data && data.address) || {}}
                                                address={
                                                    !isEmpty(billing_address)
                                                        ? billing_address
                                                        : !isEmpty(address)
                                                            ? address
                                                            : "NA" || {}
                                                }
                                                showIcon
                                                displayType="line"
                                            />
                                        </td>
                                    </tr>
                                    {!isEmpty(data.email) && (
                                        <tr>
                                            <td>
                                                <Icon type="mail" /> &nbsp; {data.email}
                                            </td>
                                        </tr>
                                    )}
                                    {!isEmpty(data.contact) && (
                                        <tr>
                                            <td>
                                                <Icon type="phone" /> &nbsp;{" "}
                                                {formatUSPhoneNumber(data.contact)}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </td>
                        <td width="35%">
                            <table>
                                <tbody>
                                    {/* <tr>
                  <td>{I18n.t('order.weight')}</td><td>:</td><td>{this.state.invoice.order_info.order_weight ? `${this.state.invoice.order_info.order_weight} ${AppConfig.weight_unit}` : 'NA'}</td>
                </tr> */}
                                    <tr>
                                        <td>{I18n.t("general.Driver")}</td>
                                        <td>:</td>
                                        <td>
                                            {this.state.invoice.driver_details
                                                ? this.state.invoice.driver_details.code ||
                                                this.state.invoice.driver_details.name ||
                                                "NA"
                                                : "NA"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{I18n.t("zones.zonename")}</td>
                                        <td>:</td>
                                        <td>{order_info.zone_name || "NA"}</td>
                                    </tr>
                                    <tr>
                                        <td>{I18n.t("zones.type")}</td>
                                        <td>:</td>
                                        <td>{order_info.zone_type || "NA"}</td>
                                    </tr>
                                    {order_info.zone_type === "location" && (
                                        <tr>
                                            <td>{I18n.t("general.zipcode")}</td>
                                            <td>:</td>
                                            <td>{order_info.zipcode || "NA"} </td>
                                        </tr>
                                    )}
                                    {order_info.zone_type === "distance" && (
                                        <tr>
                                            <td>{I18n.t("general.distance")}</td>
                                            <td>:</td>
                                            <td>
                                                {!isEmpty(order_info.distance)
                                                    ? `${parseFloat(order_info.distance).toFixed(2)} ${AppConfig.distance_unit
                                                    }`
                                                    : "NA"}{" "}
                                            </td>
                                        </tr>
                                    )}
                                    <tr>
                                        <td>{I18n.t("los.label")}</td>
                                        <td>:</td>
                                        <td>{order_info.level_of_service || "NA"}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        ) : (
            <table width="100%" style={{ ...marginTop10 }} cellpadding="0px">
                <tbody>
                    <tr>
                        <td width="65%">
                            <table width="100%">
                                <tbody>
                                    <tr>
                                        <td style={{ ...shipperHeading, ...textBold }}>
                                            <h3>{I18n.t("invoices.billed_to")}</h3>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ ...smallContent }}>
                                            <h4>{this.state.invoice.account_details.name}</h4>
                                            <AddressInfo
                                                address={(data && data.address) || {}}
                                                showIcon
                                                displayType="line"
                                            />
                                        </td>
                                    </tr>
                                    {!isEmpty(data.email) && (
                                        <tr>
                                            <td>
                                                <Icon type="mail" /> &nbsp; {data.email}
                                            </td>
                                        </tr>
                                    )}
                                    {!isEmpty(data.contact) && (
                                        <tr>
                                            <td>
                                                <Icon type="phone" /> &nbsp;{" "}
                                                {formatUSPhoneNumber(data.contact)}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </td>
                        <td width="35%" />
                    </tr>
                </tbody>
            </table>
        );
    };

    renderReference = () => {
        const orderInfo = this.state.invoice.order_info || {};
        return (
            <Row>
                {(!isEmpty(orderInfo.mawb) || !isEmpty(orderInfo.hawb)) && (
                    <Col xs={24}>
                        <h4 style={{ marginBottom: 0, marginLeft: 9 }}>
                            {I18n.t("order.reference_label")}
                        </h4>
                        {!isEmpty(orderInfo.mawb) && (
                            <Row>
                                <Col xs={24} style={{ marginLeft: 20, fontSize: 13 }}>
                                    <span>{I18n.t("general.mawb")}&nbsp;&nbsp;:&nbsp;&nbsp;</span>
                                    <span>
                                        <span>{doFormate(orderInfo.mawb)}</span>
                                    </span>
                                </Col>
                            </Row>
                        )}
                        {!isEmpty(orderInfo.hawb) && (
                            <Row>
                                <Col xs={24} style={{ marginLeft: 20, fontSize: 13 }}>
                                    <span>{I18n.t("general.hawb")}&nbsp;&nbsp;:&nbsp;&nbsp;</span>
                                    <span>
                                        <span>{doFormate(orderInfo.hawb)}</span>
                                    </span>
                                </Col>
                            </Row>
                        )}
                    </Col>
                )}
            </Row>
        );
    };

    renderDetails = () => {
        const orders_info = this.state.invoice_ref?.orders_info
            ? this.state.invoice_ref.orders_info
            : [];
        const account_details = this.state.invoice_ref?.account_details
            ? this.state.invoice_ref.account_details
            : {};
        const appointmentDate = this.props.order?.scheduled_start_datetime ? moment.utc(this.props.order.scheduled_start_datetime) : moment();
        const locations = this.props.order?.locations

        const { isEstimateModalVisible, dataSource, estimateData, } = this.state;
        const { totalDistance, totalRate } = this.calculateTotals();
        const {form} = this.props

        const columns = [
            {
                title: "Stop",
                dataIndex: "type_of_loc",
                key: "stop",
                width: 100,
                align: "left",
                render: (text, record) => {
                    console.log(record);
                    return (
                        <div>
                            {record.stop === "Pickup" ? (
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    <PickupIconEstimate />  &nbsp; Pickup
                                </span>
                            ) : record.stop === "Delivery" ? (
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    <DeliveryIconEstimate /> &nbsp; Delivery
                                </span>
                            ) : (
                                record.stop
                            )}
                        </div>
                    )
                },
            },
            {
                title: "Distance",
                dataIndex: "distance",
                key: "distance",
                width: 150,
                align: "center",
                render: (text, record) => (
                    <Input
                        value={text}
                        onChange={(e) =>
                            this.handleTableChange(e.target.value, record.location_id, "distance")
                        }
                        suffix="mi"
                        className="table-input"
                    />
                ),
            },
            {
                title: "Rate",
                dataIndex: "amount",
                key: "amount",
                width: 150,
                align: "center",
                render: (text, record) => (
                    <Input
                        value={text}
                        prefix="$"
                        onChange={(e) =>
                            this.handleTableChange(e.target.value, record.location_id, "amount")
                        }
                        className="table-input"
                    />
                ),
            },
            {
                title: "Includes Fuel",
                dataIndex: "include_fuel_surcharge",
                key: "include_fuel_surcharge",
                width: 100,
                align: "center",
                render: (checked, record) => (
                    <Checkbox
                        checked={checked}
                        onChange={(e) =>
                            this.handleTableChange(e.target.checked, record.location_id, "include_fuel_surcharge")
                        }
                    />
                ),
            },
        ];
        return (
            <Fragment>
                {checkServiceExistance("BLC") && this.state.callInvoceDetails && (
                    <Fragment>
                        {/* <Row type='flex' justify='end' gutter={8}>
                            <Col>
                                <Button
                                    className="small-btn flat"
                                    type="link"
                                    size="small"
                                    onClick={() =>
                                        this.handleGenerateQuotation(this.state.order_id)
                                    }
                                >
                                    {I18n.t("general.recalculate")}
                                </Button>
                            </Col>
                            <Col>
                                <Button_v2
                                    // type="primary"
                                    // className="button-large-estimate"
                                    className="small-btn raised"
                                    onClick={() => this.handlePrintBills(this.state.order_id)}
                                    loading={this.state.printProgress}
                                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                >
                                    <PrintEstimateIcon />
                                    {I18n.t("general.print")}
                                </Button_v2>
                            </Col>
                            <Col>
                                <Button_v2
                                    className="small-btn raised"
                                    onClick={() => this.showEmailModal()}
                                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                >
                                    <SendEmailIcon />
                                    {I18n.t("general.email")}
                                </Button_v2>
                            </Col>
                        </Row> */}
                        <Row className="company-estimate-details" gutter={8} type="flex" justify='space-between' align='bottom'>
                            <Col span={12}>
                                <img src={this.state.logo} alt="Company Logo" height="32px" width="108px"/>
                                {/* <img src="" alt="Company Logo" height={32} width={108} /> */}
                                <div className="company-details">{this.state.invoice_ref.organization_name}</div>
                            </Col>
                            <Col span={12}>
                                <Row gutter={8} type="flex" justify='end'>
                                    <Col span={12} className="alignRight">
                                        <div className="estimate-details-head">Estimated Due</div>
                                        <div className="estimate-due">{checkNegitive(this.state.invoice_ref.total_amount)}</div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="account-details-row" type="flex" justify='space-between'>
                            {account_details?.name && (
                                <Col>
                                    <div className="account-heading">Account</div>
                                    <div className="account-details">{account_details.name}, {account_details.code}</div>
                                </Col>
                            )}
                            <Col className="alignRight">
                                <div className="account-heading">Date</div>
                                <div className="date-details">{moment().format("MMM D, YYYY")}</div>
                            </Col>
                        </Row>
                        {!_.isEmpty(orders_info) && (
                            <Row className="address-info-row">
                                <Col md={24} className="address-info-rows">
                                    {orders_info?.length ? (
                                        orders_info.map((zone, index) => (
                                            <div>
                                            <Row gutter={8} type="flex">
                                                <Col className="address-location-details">
                                                    <div>{getOrderTypeIcon(zone.segment_type === "PICKUP" ? "R" : "D", { height: "16", width: "16"})}</div>
                                                    <div>{zone.segment_type} Address: </div>
                                                </Col>
                                                <Col className="address-location-details blue-text"><AddressInfo address={locations[index]?.address} /></Col>
                                            </Row>
                                            <Row key={index} className="order-info-row" type="flex" gutter={16}>
                                                {/* {zone.segment_type && (
                                                    <Col md={3} className="zone-details">
                                                        {zone.segment_type ? `${zone.segment_type} ` : ""}
                                                    </Col>
                                                )} */}
                                                <Col>
                                                    <Row type="flex" gutter={4}>
                                                        <Col className="zone-details-heading">Date:</Col>
                                                        <Col className="zone-details-desc">{locations[index]?.appointment?.appt_date
                                                            ? `${locations[index].appointment.appt_date} ${locations[index].appointment.start_time}-${locations[index].appointment.end_time}`
                                                            : "NA"}
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col className="zone-details-col">
                                                    <Row type="flex" gutter={4}>
                                                        <Col className="zone-details-heading">Zone:</Col>
                                                        <Col className="zone-details-desc">{zone?.zone_name || "NA"}</Col>
                                                    </Row>
                                                </Col>
                                                <Col className="zone-details-col">
                                                    <Row type="flex" gutter={4}>
                                                        <Col className="zone-details-heading">Type:</Col>
                                                        <Col className="zone-details-desc">{zone?.zone_type || "NA"}</Col>
                                                    </Row>
                                                </Col>
                                                <Col>
                                                    <Row type="flex" gutter={4}>
                                                        <Col className="zone-details-heading">{I18n.t("general.short_los")}:</Col>
                                                        <Col className="zone-details-desc">{zone.level_of_service}</Col>
                                                    </Row>
                                                </Col>
                                                {zone.zone_type === "location" && (
                                                    <>
                                                        <Col className="zone-details-col">
                                                            <Row type="flex" gutter={4}>
                                                                <Col className="zone-details-heading">{I18n.t("general.zipcode")}:</Col>
                                                                <Col className="zone-details-desc">{zone?.zipcode || "NA"}</Col>
                                                            </Row>
                                                        </Col>
                                                        <Col className="zone-details-col">
                                                            <Row type="flex" gutter={4}>
                                                                <Col className="zone-details-heading">{I18n.t("general.distance")}:</Col>
                                                                <Col className="zone-details-desc">
                                                                            {!isEmpty(zone.distance)
                                                                                ? `${parseFloat(zone.distance)} ${AppConfig.distance_unit
                                                                                }`
                                                                                : "NA"}
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </>
                                                )}
                                                {zone.zone_type === "distance" && (
                                                    <Col className="zone-details-col">
                                                        <Row>
                                                            <Col md={24}>
                                                                <div className="">
                                                                    <span className="zone-details-heading">
                                                                        {I18n.t("general.distance")}:
                                                                    </span>
                                                                    <span className="zone-details-desc">
                                                                        {" "}
                                                                        {!isEmpty(zone.distance)
                                                                            ? `${parseFloat(zone.distance)} ${AppConfig.distance_unit
                                                                            }`
                                                                            : "NA"}
                                                                    </span>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                )}
                                                {/* <Col>
                                                    <Row type="flex" gutter={4}>
                                                        <Col className="zone-details-heading">LOS:</Col>
                                                        <Col className="zone-details-desc">{zone.level_of_service}</Col>
                                                    </Row>
                                                </Col> */}
                                            </Row>
                                            </div>
                                        ))
                                    ) : (
                                        <Fragment />
                                    )}
                                </Col>
                            </Row>
                        )}
                    </Fragment>
                )}
                {this.state.invoice?.is_prepaid === true && (
                    <Row className="prepaid-amount-banner-row">
                        <Col span={24}>
                            <PrepaidAmountWithPreview
                                amount={this.state.invoice.prepaid_amount}
                                cashReceiptLegs={this.state.invoice.cash_receipt_pictures}
                            />
                        </Col>
                    </Row>
                )}
                {this.state.currentOrderGroupType !== "TEMPLATE" &&
                    this.state.chargeTypes
                        .filter(
                            (sectionType) =>
                                this.state.invoice_ref[sectionType] &&
                                this.state.invoice_ref[sectionType].length > 0
                        )
                        .map((sectionType) => {
                            const order_references = this.state?.order_references
                                ? this.state.order_references
                                : {};
                            const orderObj =
                                _.find(this.state.invoice_ref.transportation_charges, {
                                    order_id: this.state.order_id,
                                }) || {};
                            const locations =
                                sectionType === "transportation_charges" && orderObj?.locations
                                    ? orderObj.locations
                                    : [];
                            return (
                                <div className="charges-table-view">
                                    {/* <Row type="flex" justify='space-between' align="center" className="charge-details-row"> */}
                                        {/* <Col className="section-type"> */}
                                            {/* {I18n.t(`invoices.${sectionType}`)} */}
                                        {/* </Col> */}

                                        {/* <Col> */}
                                            {/* <Row type='flex' gutter={24}>
                                                <Col className="charge-details-desc">
                                                    {sectionType === "transportation_charges"
                                                        ? this.state.invoice.transportation_gl_code
                                                            ?
                                                            <>
                                                                <span className="charge-desc-head">{`${I18n.t("invoices.gl_code")}:`}</span>
                                                                <span className="charge-desc-details">{this.state.invoice.transportation_gl_code}</span>
                                                            </>
                                                            : ""
                                                        : ""}
                                                </Col>

                                                {sectionType === "transportation_charges"
                                                    ? locations.map((loc) => (
                                                        <Col className="charge-details-desc">
                                                            <span className="charge-desc-head">
                                                                {loc.order_type ? (
                                                                    <span className="textCaptilize">
                                                                        {_.lowerCase(loc.order_type)}
                                                                    </span>
                                                                ) : (
                                                                    ""
                                                                )}{" "}
                                                                LoS:
                                                            </span>
                                                            <span className="charge-desc-details">{loc.level_of_service_code}</span>
                                                        </Col>
                                                    ))
                                                    : ""}
                                            </Row> */}
                                        {/* </Col> */}
                                    {/* </Row> */}
                                    <table
                                        // border="1px"
                                        cellpadding="5px"
                                        cellspacing="0px"
                                        width="100%"
                                        style={{ ...borderCollapseInherit }}
                                        className="charge-details-table"
                                    >
                                        <tbody>
                                            <tr>
                                                {/* <td width="32px" className="table-heading">
                                                    #
                                                </td> */}
                                                <td width={sectionType === "adjustment_charges" ? "74px" : "386px"} className="table-heading">
                                                    {I18n.t(`invoices.${sectionType}`)}
                                                </td >
                                                {sectionType === "adjustment_charges" && this.state.editMode &&
                                                    <td width="74px" className="table-heading">
                                                        Location
                                                    </td>
                                                }
                                                {sectionType === "adjustment_charges" &&
                                                <td width="97px" className="table-heading">
                                                    {`${I18n.t("invoices.gl_code")}`}
                                                </td>
                                                }
                                                <td width="97px" className="table-heading alignRight">
                                                    {I18n.t("invoices.units")}
                                                </td>
                                                <td width="97px" className="table-heading alignRight">
                                                    {I18n.t("invoices.amount")}
                                                </td>
                                                {sectionType === "adjustment_charges" && this.state.editMode && 
                                                <td width="32px" className="table-heading" style={{cursor: 'pointer'}}>
                                                    <AdditionIcon onClick={this.handleAddRow} />
                                                </td>
                                                }
                                            </tr>
                                            {this.state.invoice_ref[sectionType].map((order, index) => {
                                                
                                                // for not showing zero values in adjustments
                                                const priceList = !isEmpty(order.price_list)
                                                    ? sectionType === "adjustment_charges" && this.state.editMode === false
                                                        ? order.price_list.filter(
                                                            (item) => item.id// > 0
                                                        )
                                                        : [...order.price_list]
                                                    : [];                                                    
                                                return priceList.length > 0 ? (
                                                    <Fragment>
                                                        {/* <tr>
                                                            <td
                                                                className="tbody-item-head"
                                                            // style={{ ...invoiceItem, ...alignCenter }}
                                                            >
                                                                {index + 1}
                                                            </td>
                                                            <td
                                                                className="tbody-item-head"
                                                            // style={{ ...invoiceItem, ...textBold }}
                                                            >
                                                                #{order.order_number}&nbsp;
                                                                {order_references[order.order_number] && (
                                                                    <HawbMawbNo
                                                                        record={
                                                                            order_references[order.order_number]
                                                                        }
                                                                    />
                                                                )}
                                                            </td>
                                                            <td
                                                                className="tbody-item-head"
                                                            // style={{ ...invoiceItem }}
                                                            >&nbsp;</td>
                                                            <td
                                                                className="tbody-item-head"
                                                            // style={{ ...invoiceItem, ...alignRight }}
                                                            >
                                                                &nbsp;
                                                            </td>
                                                        </tr> */}

                                                        {priceList // filter(invoiceItem => invoiceItem.invoice_value !== 0)
                                                            .map((item, itemIndex) => {                                                                
                                                                const rowSpan = findSpanValue(
                                                                    priceList,
                                                                    item,
                                                                    itemIndex
                                                                );
                                                                return (
                                                                    <tr>
                                                                        {/* <td
                                                                            className="tbody-item-body"
                                                                        // style={{ ...invoiceItem, ...alignCenter }}
                                                                        > */}
                                                                        {/* {sectionType === "adjustment_charges"
                                                                            ? itemIndex + 1
                                                                            : ""} */}
                                                                        {/* </td> */}
                                                                        <td
                                                                            className="tbody-item-body"
                                                                        // style={{ ...invoiceItem }}
                                                                        >
                                                                            {this.state.editMode && sectionType === "adjustment_charges" ?
                                                                                <Form.Item>
                                                                                    {form.getFieldDecorator(`invoice_name_${itemIndex}`, {
                                                                                        initialValue: item.invoice_name,
                                                                                        rules: [
                                                                                            { required: true, message: 'Required!' },
                                                                                        ],
                                                                                    })(
                                                                                        <Input
                                                                                            // value={item.invoice_name}
                                                                                            onChange={(e) => this.handleChange("invoice_name", e.target.value, itemIndex)}
                                                                                        />)}
                                                                                </Form.Item> :
                                                                            <>
                                                                            {item.invoice_name}{" "}
                                                                            {item.item_description ? (
                                                                                <i style={{ ...fontSize10 }}>
                                                                                    {" "}
                                                                                    {item.item_description}{" "}
                                                                                </i>
                                                                            ) : (
                                                                                ""
                                                                            )}
                                                                            {item.added_from === "MANUAL" && (
                                                                                <sup className="textRed textBold">
                                                                                    M
                                                                                </sup>
                                                                            )}
                                                                            </>
                                                                        }
                                                                        </td>
                                                                        {sectionType === "adjustment_charges" && this.state.editMode &&
                                                                        <td
                                                                            className="tbody-item-body alignRight"
                                                                        >
                                                                            <Form.Item>
                                                                                {form.getFieldDecorator(`location_type_${itemIndex}`, {
                                                                                    initialValue: this.props.order.locations.length === 1 ? this.props.order.locations[0].type_of_loc : item.location_type,
                                                                                    rules: [
                                                                                        { required: true, message: 'Required', },
                                                                                    ]
                                                                                })(
                                                                            <Select
                                                                                dropdownMatchSelectWidth={false}
                                                                                onChange={(value) => this.handleChange("location_details", value, itemIndex)}
                                                                                // value={this.props.order.locations.length === 1 ? this.props.order.locations[0].type_of_loc : item.location_type}
                                                                                style={{width: "58px"}}
                                                                            >
                                                                                {this.props.order.locations.map((loc) => (
                                                                                    <Select.Option key={loc.id} value={loc.type_of_loc}>
                                                                                        {loc.type_of_loc}
                                                                                    </Select.Option>
                                                                                ))}
                                                                            </Select>
                                                                            )}
                                                                            </Form.Item>
                                                                        </td>
                                                                        }
                                                                        {sectionType === "adjustment_charges" &&
                                                                        <td
                                                                            className="tbody-item-body alignRight"
                                                                            rowSpan={rowSpan} 
                                                                        >
                                                                            {this.state.editMode ?
                                                                            <Form.Item>
                                                                                {form.getFieldDecorator(`gl_code_${itemIndex}`,{
                                                                                    initialValue: item.gl_code,
                                                                                    rules: [
                                                                                        { required: true, message: 'Required'}
                                                                                    ]
                                                                                })(
                                                                            <GLCodeSelect
                                                                                data={this.state.glCodesList || []}
                                                                                // value={item.gl_code}
                                                                                onChange={(value) => this.handleChange("gl_code",value,itemIndex)}
                                                                            />
                                                                            )}
                                                                            </Form.Item>
                                                                            :
                                                                            <>
                                                                            {item.gl_code}
                                                                            </>
                                                                            }
                                                                        </td>
                                                                        }
                                                                        {rowSpan !== 0 && (
                                                                            <td
                                                                                className="tbody-item-body alignRight"
                                                                                // style={{ ...invoiceItem }}
                                                                                rowSpan={rowSpan}
                                                                            >
                                                                                {rowSpan === 1 ? (
                                                                                    this.state.editMode && sectionType === "adjustment_charges" ?
                                                                                    <Form.Item>
                                                                                        {form.getFieldDecorator(`invoice_quantity_${itemIndex}`, {
                                                                                            initialValue: item.invoice_quantity,
                                                                                            rules: [
                                                                                                { required: true, message: 'required'}
                                                                                            ]
                                                                                        })(
                                                                                    <InputNumber   
                                                                                        // value={item.invoice_quantity}
                                                                                        min={1}
                                                                                        onChange={(value) => this.handleChange("invoice_quantity", value, itemIndex)}
                                                                                    />
                                                                                )}
                                                                                    </Form.Item>
                                                                                    :
                                                                                    !isEmpty(item.invoice_quantity) &&
                                                                                        item.invoice_quantity !== 0 ? (
                                                                                        item.invoice_quantity
                                                                                    ) : (
                                                                                        <Fragment>&nbsp;</Fragment>
                                                                                    )
                                                                                ) : (
                                                                                    rowSpan
                                                                                )}
                                                                            </td>
                                                                        )}
                                                                        {rowSpan !== 0 && (
                                                                            <td
                                                                                className="tbody-item-body alignRight"
                                                                                // style={{
                                                                                //   ...invoiceItem,
                                                                                //   ...alignRight,
                                                                                // }}
                                                                                rowSpan={rowSpan}
                                                                            >
                                                                                {this.state.editMode && sectionType === "adjustment_charges" ?
                                                                                <Form.Item>
                                                                                    {form.getFieldDecorator(`invoice_value_${itemIndex}`, {
                                                                                        initialValue: item.invoice_value,
                                                                                        rules: [
                                                                                            { required: true, message: 'Required'}
                                                                                        ]
                                                                                    })(
                                                                                <InputNumber
                                                                                    // value={item?.invoice_value}
                                                                                    onChange={(value) => this.handleChange("invoice_value", value, itemIndex)}
                                                                                    min={0}
                                                                                />
                                                                            )}
                                                                                </Form.Item>
                                                                                :
                                                                                    checkNegitive(item.invoice_value)
                                                                                }
                                                                            </td>
                                                                        )}
                                                                        {sectionType === "adjustment_charges" && this.state.editMode && 
                                                                            <td width="32px" className="tbody-item-body" style={{cursor: 'pointer'}}>
                                                                                <Popconfirm
                                                                                    placement="left"
                                                                                    title={I18n.t("messages.delete_confirm")}
                                                                                    onConfirm={() => this.handleDelete(itemIndex)}
                                                                                    okText="Yes"
                                                                                    cancelText="No"
                                                                                >
                                                                                    <TrashIcon styling={{ width: '16px', height: '16px' }} color={'#576EC1'} />
                                                                                </Popconfirm>
                                                                            </td>
                                                                        }
                                                                    </tr>
                                                                );
                                                            })}
                                                    </Fragment>
                                                ) : (
                                                    <Fragment />
                                                );
                                            })}
                                        </tbody>
                                    </table>

                                    <table width="100%" className="invoice-amount-table">
                                        <tbody>
                                            <tr>
                                                <td width="277px"
                                                    className="invoice-sub-total"
                                                // style={{ ...marginTop40 }} 
                                                />
                                                <td width="296px" style={{ padding: 0 }}>
                                                    <table width="100%">
                                                        <tbody>
                                                            <tr>
                                                                <td
                                                                    width="148px"
                                                                    className="invoice-sub-total alignRight"
                                                                // style={{ ...alignRight, ...totalItems }}
                                                                >
                                                                    {I18n.t("invoices.sub_total")}
                                                                </td>
                                                                <td
                                                                    width="148px"
                                                                    className="invoice-sub-total alignRight"
                                                                // style={{
                                                                //   ...alignRight,
                                                                //   ...totalItems,
                                                                //   ...textBold,
                                                                // }}
                                                                >
                                                                    {this.findSectionTotal(sectionType)}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            );
                        })}
                {this.state.currentOrderGroupType === "TEMPLATE" && (
                    <div style={{ ...borderLine, ...marginTop20, ...padding5 }}>
                        <Row type="flex" gutter={32}>
                            <Col>
                                <h5>Charges</h5>
                            </Col>
                        </Row>
                        <table
                            border="1px"
                            cellPadding="5px"
                            cellSpacing="0px"
                            width="100%"
                            style={{ ...borderCollapseInherit }}
                        >
                            <tbody>
                                <tr>
                                    <td width="4%" style={{ ...heading, ...alignCenter }}>
                                        #
                                    </td>
                                    <td width="58%" className="heading">
                                        {I18n.t("general.description")}
                                    </td>
                                    <td width="16%" className="heading">
                                        {I18n.t("invoices.units")}
                                    </td>
                                    <td width="22%" className="heading alignRight">
                                        {I18n.t("invoices.amount")}
                                    </td>
                                </tr>
                                {this.state.invoice_ref.transportation_charges.map(
                                    (order, index) => {
                                        const priceList = !isEmpty(order.price_list)
                                            ? order.price_list
                                            : [];
                                        return priceList.length > 0 ? (
                                            <Fragment key={order.order_number}>
                                                <tr>
                                                    <td style={{ ...invoiceItem, ...alignCenter }}>
                                                        {index + 1}
                                                    </td>
                                                    <td style={{ ...invoiceItem, ...textBold }}>
                                                        #{order.order_number}&nbsp;
                                                        {this.state?.order_references?.[
                                                            order.order_number
                                                        ] && (
                                                                <HawbMawbNo
                                                                    record={
                                                                        this.state.order_references[
                                                                        order.order_number
                                                                        ]
                                                                    }
                                                                />
                                                            )}
                                                    </td>
                                                    <td style={{ ...invoiceItem }}>&nbsp;</td>
                                                    <td style={{ ...invoiceItem, ...alignRight }}>
                                                        &nbsp;
                                                    </td>
                                                </tr>
                                                {priceList.map((item, itemIndex) => {
                                                    const rowSpan = findSpanValue(
                                                        priceList,
                                                        item,
                                                        itemIndex
                                                    );
                                                    return (
                                                        <tr key={itemIndex}>
                                                            <td style={{ ...invoiceItem, ...alignCenter }} />
                                                            <td style={{ ...invoiceItem }}>
                                                                {item.invoice_name}{" "}
                                                                {item.item_description && (
                                                                    <i style={{ ...fontSize10 }}>
                                                                        {" "}
                                                                        {item.item_description}{" "}
                                                                    </i>
                                                                )}
                                                                {item.added_from === "MANUAL" && (
                                                                    <sup className="textRed textBold">M</sup>
                                                                )}
                                                            </td>
                                                            {rowSpan !== 0 && (
                                                                <td
                                                                    style={{ ...invoiceItem }}
                                                                    rowSpan={rowSpan}
                                                                >
                                                                    {rowSpan === 1 ? (
                                                                        !isEmpty(item.invoice_quantity) &&
                                                                            item.invoice_quantity !== 0 ? (
                                                                            item.invoice_quantity
                                                                        ) : (
                                                                            <Fragment>&nbsp;</Fragment>
                                                                        )
                                                                    ) : (
                                                                        rowSpan
                                                                    )}
                                                                </td>
                                                            )}
                                                            {rowSpan !== 0 && (
                                                                <td
                                                                    style={{ ...invoiceItem, ...alignRight }}
                                                                    rowSpan={rowSpan}
                                                                >
                                                                    {checkNegitive(item.invoice_value)}
                                                                </td>
                                                            )}
                                                        </tr>
                                                    );
                                                })}
                                            </Fragment>
                                        ) : (
                                            <Fragment key={order.order_number} />
                                        );
                                    }
                                )}
                            </tbody>
                        </table>
                        <table width="100%" style={{ ...marginTop20 }}>
                            <tbody>
                                <tr>
                                    <td width="62.5%" style={{ ...marginTop40 }} />
                                    <td width="37.5%">
                                        <table width="100%">
                                            <tbody>
                                                <tr>
                                                    <td
                                                        width="42%"
                                                        style={{ ...alignRight, ...totalItems }}
                                                    >
                                                        {I18n.t("invoices.sub_total")}
                                                    </td>
                                                    <td
                                                        width="58%"
                                                        style={{
                                                            ...alignRight,
                                                            ...totalItems,
                                                            ...textBold,
                                                        }}
                                                    >
                                                        {this.findSectionTotal("transportation_charges")}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )}
                <table width="100%" className="total-amount-section">
                    <tbody>
                        <tr>
                            <td width="277px" style={{ ...marginTop40 }}>
                                {this.state.showOtherDetails && this.renderComments()}
                            </td>
                            <td width="296px" style={{ padding: 0 }}>
                                <table width="100%">
                                    <tbody>
                                        {false && (
                                            <tr>
                                                <td
                                                    width="42%"
                                                    style={{ ...alignRight, ...totalItems }}
                                                >
                                                    {I18n.t("invoices.sub_total")}
                                                </td>
                                                <td
                                                    width="58%"
                                                    style={{ ...alignRight, ...totalItems, ...textBold }}
                                                >
                                                    {this.state.currentOrderGroupType !== "TEMPLATE"
                                                        ? this.state.invoice_ref.sub_total
                                                            ? checkNegitive(this.state.invoice_ref.sub_total)
                                                            : checkNegitive(this.state.invoice_ref.total_amount)
                                                        : ""}
                                                    {this.state.currentOrderGroupType === "TEMPLATE" &&
                                                        this.findSectionTotal("transportation_charges")}
                                                </td>
                                            </tr>
                                        )}
                                        <tr>
                                            <td
                                                width="148px"
                                                className="taxable-row alignRight"
                                            // style={{ ...alignRight, ...totalItems }}
                                            >
                                                {I18n.t("invoices.taxable")}
                                            </td>
                                            <td
                                                width="148px"
                                                className="taxable-row alignRight"
                                            // style={{ ...alignRight, ...totalItems, ...textBold }}
                                            >
                                                {checkNegitive(this.state.invoice_ref.taxable)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                width="148px"
                                                className="total-amount alignRight"
                                            // style={{ ...alignRight, ...totalItems, ...textBold }}
                                            >
                                                {I18n.t("invoices.total")}
                                            </td>
                                            <td
                                                width="148px"
                                                className="total-amount alignRight"
                                            // style={{ ...alignRight, ...totalItems, ...textBold }}
                                            >
                                                {checkNegitive(this.state.invoice_ref.total_amount)}
                                            </td>
                                        </tr>
                                        {/* <tr>
                      <td colspan="2" style={{ height: 85 }} />
                    </tr> */}
                                        {this.state.showOtherDetails && (
                                            <tr>
                                                <td
                                                    colspan="2"
                                                    style={{
                                                        ...alignCenter,
                                                        ...textBold,
                                                        ...totalItems,
                                                    }}
                                                >
                                                    [{" "}
                                                    {this.state.invoice_ref.organization_name ||
                                                        "Company Name"}{" "}
                                                    ]
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
                {this.state.showEmailModal && this.renderEmailModal()}
                <EditEstimateModal
                    requestFrom="invoice"
                    isModalVisible={isEstimateModalVisible}
                    handleCancel={this.handleEstimateModalCancel}
                    handleOk={this.handleEstimateModalOk}
                    invoiceDataSource={dataSource}
                    invoiceColumns={columns}
                    totalDistance={totalDistance}
                    totalRate={totalRate}
                    handleTableChange={this.handleTableChange}
                    initialData={estimateData}
                />
            </Fragment>
        );
    };
    renderSignatutes = () => {
        const podPics = this.state.invoice.pod_pictures
            ? this.state.invoice.pod_pictures
            : [];
        const signaturePics = [];
        podPics.forEach((picData) => {
            if (picData.pictures) {
                const signs = picData.pictures
                    .filter(
                        (pic) =>
                            pic.image_type === "signature" && pic.picture && pic.picture.url
                    )
                    .map((pic) => {
                        return { url: pic.picture.url, sign_by: pic.sign_by };
                    });
                if (signs.length > 0) {
                    signaturePics.push({
                        sign: signs[0].url,
                        order_number: picData.customer_order_number,
                        sign_by: signs[0].sign_by,
                    });
                }
            }
        });
        return (
            <Fragment>
                {signaturePics.map((pic, index) =>
                    index === 0 ? (
                        <div
                            class="textCenter"
                            style={{
                                width: "100%",
                                ...floatLeft,
                                ...borderLine,
                                ...padding5,
                                ...marginTop10,
                                ...marginLeft10,
                            }}
                        >
                            <div>
                                <img src={pic.sign} alt="sign" style={{ width: "100%" }} />
                            </div>
                            <div style={{ ...alignCenter, ...textBold }}>
                                Sign By: {pic.sign_by}
                            </div>
                        </div>
                    ) : null
                )}
            </Fragment>
        );
    };

    renderPodPictures = () => {
        const podPics = this.state.invoice.pod_pictures
            ? this.state.invoice.pod_pictures
            : [];
        const normalPics = [];
        podPics.forEach((picData) => {
            if (picData.pictures) {
                const signs = picData.pictures
                    .filter(
                        (pic) =>
                            pic.image_type === "normal" && pic.picture && pic.picture.url
                    )
                    .map((pic) => {
                        return { url: pic.picture.url, pic_title: pic.pic_title };
                    });
                if (signs.length > 0) {
                    normalPics.push({
                        sign: signs[0].url,
                        order_number: picData.customer_order_number,
                    });
                }
            }
        });
        return (
            <Fragment>
                {normalPics.map((pic, index) => (
                    <div
                        class="textCenter"
                        style={{
                            width: "100%",
                            ...floatLeft,
                            ...borderLine,
                            ...padding5,
                            ...marginTop10,
                            ...marginLeft10,
                        }}
                        key={`image${index}`}
                    >
                        <div>
                            <img src={pic.sign} alt="PIC" style={{ width: "100%" }} />
                        </div>
                        <div style={{ ...alignCenter }}>Order No: #{pic.order_number}</div>
                    </div>
                ))}

            </Fragment>
        );
    };

    _renderInvoce = () => {
        return (
            <Spin spinning={this.state.inProgress} delay={1000}>
                {this.state.showHeading && this.renderWHDetails()}
                {this.state.showOtherDetails && this.renderShipperDetails()}
                {false && this.renderReference()}
                {this.renderDetails()}
                {this.state.showOtherDetails && (
                    <Fragment>
                        {this.renderPodPictures()}
                        {this.renderSignatutes()}
                        <Row>
                            <Col
                                xs={24}
                                className="alignCenter smallText marginTop40 fontSize15"
                            >
                                For all terms & conditions please refer{" "}
                                <a href="https://fleetenable.com/">
                                    <u className="text-decoration-dashed">here</u>
                                </a>
                            </Col>
                        </Row>
                    </Fragment>
                )}
            </Spin>
        );
    };

    render() {
        const { account } = this.state;
        return (
            <div className="invoice-box">
                <this._renderInvoce />
            </div>
        );
    }
}

export const EstimateDetails = withRouter((props) => {
    const { orgSettings: organizationSettings, currentOrg, glCodesList } = useContext(OrgContext);
    return <FormComponent {...props} organizationSettings={organizationSettings} currentOrg={currentOrg} glCodesList={glCodesList} />;
});

export default Form.create()(EstimateDetails);